export const getLinkTg = (val) => {
  const country = localStorage.getItem("Country");
  return country && country.toLocaleLowerCase() === "usa"
    ? "?tag=kmusaf0b-20&"
    : "?tag=amprioz-21&";
};
